export default __webpack_public_path__ + "static/media/solicitud_de_medico_privado.93529728.pdf";